"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendEvent = void 0;
var firefly_utilities_ts_1 = require("firefly-utilities-ts");
var firefly_utilities_helper_ts_1 = require("firefly-utilities-helper-ts");
function sendEvent(json, apiKey, schemaId, url, retries) {
    var payload = [json];
    if ((0, firefly_utilities_helper_ts_1.isString)(url) && (url.indexOf('/v1') > -1 && url.indexOf('/consumers/v1/ingest') === -1)) {
        payload = {
            schema_id: schemaId,
            records: [json]
        };
    }
    var headers = {
        'x-api-key': apiKey
    };
    return firefly_utilities_ts_1.Request.postJSON(payload, headers, url, retries);
}
exports.sendEvent = sendEvent;
